module.exports = __webpack_public_path__ + "img/crane_2.422bc2ea.svg";